import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useLang } from "contexts/lang-context";

type localeType = {
  locale: string;
  path: string;
};

type HreflangControlledType = {
  localizations: localeType[];
};

const HreflangControlled: React.FC<HreflangControlledType> = ({
  localizations,
}) => {
  const router = useRouter();
  const { setUrls } = useLang();

  const localeUrls = localizations ? localizations.map((item: any, index: number) => ({
    id: item.id || index,
    locale: item.locale,
    url: item.path || router.asPath
  })) : [];

  useEffect(() => {
    setUrls(localeUrls)
  }, [router.asPath])

  return (
    <Head>
      {localizations &&
        localizations.map((item: localeType, index: number) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={item.locale}
            href={`${process.env.NEXT_PUBLIC_SITE_URL}/${item.locale}${
              item.path || router.asPath
            }`}
          />
        ))}
    </Head>
  );
};

export default HreflangControlled;
